import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import 'react-toastify/dist/ReactToastify.css'

import Loading from '@components/loading'
import FormTitle from '@components/text/formTitle'
import FormInput from '@components/inputs/formInput'
import UserProfile from '@components/userProfile'
import PrimaryButton from '@components/inputs/button/primaryButton'
import RequiredFields from '@components/requiredFields'

import {
  Container,
  TitleContainer,
  ButtonContainer,
  FormFields,
  Section,
} from './styles'

import {
  phoneMask, cpfMask, dateMask, onlyLettersMask
} from '@util/stringUtil'
import showToast from '@util/ToastUtil'
import { saveProfile as saveProfileAction, getProfile as getProfileAction } from '@actions/user'
import { validateBeneficiaryFields, hasChanges } from '@util/validationUtil'
import { WindowContext } from '@components/windowContextProvider'

const ProfileModal = ({
  saveProfile, isOpen, setClose, profile, getProfile
}) => {
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [user, setUser] = useState({})
  const [originalUser, setOriginalUser] = useState({})
  const {
    name, email, phoneNumber, birthdate, cpf
  } = user

  const { clientHeight } = React.useContext(WindowContext)

  useEffect(() => {
    if (profile) {
      setUser(profile)
      setOriginalUser(profile)
    }
  }, [profile])

  function checkOnUnfocus(label, value) {
    const error = validateBeneficiaryFields[label](value)
    if (error) {
      setErrors({
        ...errors,
        [label]: error
      })
    } else {
      const aux = errors
      delete aux[label]
      setErrors({ ...aux })
    }
  }

  const onChange = (e, field) => {
    setUser({
      ...user,
      [field]: e.target.value,
    })
  }

  const onProfileChange = (data) => {
    setLoading(false)
    if (data) {
      getProfile()
      setOriginalUser(user)
      setClose()
      showToast('success', 'Dados salvos com sucesso!', null)
    }
  }

  const handleClickSave = () => {
    setLoading(true)
    saveProfile(user, onProfileChange)
  }

  return (
    <Container isOpen={isOpen} clientHeight={clientHeight}>
      <Section>
        <TitleContainer>
          <FormTitle title="Perfil" onClickGoBack={setClose} />
          <UserProfile onClick={() => { }} />
        </TitleContainer>
        <FormFields>
          <FormInput
            value={onlyLettersMask(name)}
            onChange={(e) => onChange(e, 'name')}
            label="Nome completo"
            onBlur={() => checkOnUnfocus('name', name)}
            error={errors.name}
            required
          />
          <FormInput
            value={email}
            onChange={(e) => onChange(e, 'email')}
            onBlur={() => checkOnUnfocus('email', email)}
            error={errors.email}
            label="E-mail"
            required
          />
          <FormInput
            value={phoneMask(phoneNumber)}
            onChange={(e) => onChange(e, 'phoneNumber')}
            label="Celular"
            maxLength={15}
            error={errors.phoneNumber}
            onBlur={() => checkOnUnfocus('phoneNumber', phoneNumber)}
          />
          <FormInput
            value={dateMask(birthdate)}
            onChange={(e) => onChange(e, 'birthdate')}
            label="Data de nascimento"
            onBlur={() => checkOnUnfocus('birthdate', birthdate)}
            error={errors.birthdate}
            required
          />
          <FormInput
            value={cpfMask(cpf)}
            onChange={(e) => onChange(e, 'cpf')}
            label="CPF"
            onBlur={() => checkOnUnfocus('cpf', cpf)}
            error={errors.cpf}
            required
          />
          <RequiredFields />
        </FormFields>
      </Section>
      <ButtonContainer>
        <PrimaryButton
          onClick={() => handleClickSave()}
          disabled={!hasChanges(user, originalUser)}
        >
          {loading ? <Loading /> : 'Salvar'}
        </PrimaryButton>
      </ButtonContainer>
    </Container>
  )
}

ProfileModal.propTypes = {
  profile: PropTypes.shape({
    name: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
    birthdate: PropTypes.string,
    cpf: PropTypes.string,
  }),
  isOpen: PropTypes.bool,
  setClose: PropTypes.func.isRequired,
  saveProfile: PropTypes.func.isRequired,
  getProfile: PropTypes.func.isRequired,
}

ProfileModal.defaultProps = {
  profile: null,
  isOpen: false,
}

const mapStateToProps = ({ user }) => ({
  profile: user.profile,
})

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    saveProfile: saveProfileAction,
    getProfile: getProfileAction,
  },
  dispatch
)

export default connect(mapStateToProps, mapDispatchToProps)(ProfileModal)
